import commonUtils from "../../utils/common.utils";
import { getSpecOptionFrontEndName } from "@/utils/productName.utils";

export default class OrderSpec {
    constructor(data) {
        this.id = commonUtils.generateId();
        // 送 API 用規格選項基本名稱（第1段），clone 後處理避免影響原規格資料
        this.productSpec = this.normalizeSpecOptionNames(data.productSpec);
        this.subSpecOptionSelectCount = data.subSpecOptionSelectCount;
        this.mustHave = data.mustHave;
        this.frontEndDisplayName = data.frontEndDisplayName;
        this.isSingleSelection = data.isSingleSelection;
        this.multiSelectionMin = data.multiSelectionMin;
        this.multiSelectionMax = data.multiSelectionMax;
        this.allowSelectManyTimes = data.allowSelectManyTimes;
        this.addSortingOrder()
        this.deleteSubSpecID(data)
    }

    normalizeSpecOptionNames(productSpec) {
        if (!productSpec) return productSpec
        const cloned = structuredClone(productSpec)
        if (Array.isArray(cloned.specOptions)) {
            cloned.specOptions.forEach((opt) => {
                if (opt && typeof opt.name === 'string') opt.name = getSpecOptionFrontEndName(opt.name)
            })
        }
        return cloned
    }

    addSortingOrder() {
        this.productSpec.sortingOrder = -1
    }

    deleteSubSpecID(data) {
        delete data.subSpecID
    }
}